import { useEffect, useState } from "react";
import { useQuery } from "react-query";

export interface IBusinessParam {
  biz: string;
  accessId: string;
  accountType?: string;
}

export function useBusinessParam() {
  const [businessParam, setBusinessParam] = useState<IBusinessParam>();

  const { data } = useQuery<IBusinessParam>(
    "/api/rendering/user/getBusinessParam"
  );
  useEffect(() => {
    if (!data) return;
    setBusinessParam(data);
  }, [data]);

  return businessParam;
}
